// extracted by mini-css-extract-plugin
export default {"overlay":"KH-z","bodyOpen":"LH-z","content":"MH-z","header":"NH-z","close":"OH-z","closeNoHeading":"PH-z"};